import { captureException } from '@sentry/react';
import axios from 'axios';
import ErrorWithCause from '../../helpers/ErrorWithCause';
import { API_BASE_URL } from '@config/apiConfig';
const beginAuthorizeNetDeposit = async (request, isUsePaymentMicroserviceEnabled) => {
    const requestPath = `${API_BASE_URL}/payments/payment-deposit/authorize-net`;
    try {
        const response = await axios.post(requestPath, {
            ...request,
            coins: isUsePaymentMicroserviceEnabled && request.coins === null ? undefined : request.coins,
        });
        return response.data;
    }
    catch (error) {
        const e = new ErrorWithCause(error);
        captureException(e, {
            extra: {
                requestMethod: 'POST',
                requestPath,
                function: 'beginAuthorizeNetDeposit',
                dataDescriptor: request.dataDescriptor,
                dataValue: request.dataValue,
            },
        });
        // If the order couldn't be recorded, throw an error and the process should fail.
        throw e;
    }
};
export default beginAuthorizeNetDeposit;
